<template>
  <div class="jurisd">
    <div v-for="(item,index) in form.authData" :key="index">
      <el-form-item class="width100" :label="item.authType === 1?'免费学习权限':(item.authType === 2?'收费学习权限':'学分查看权限')" :required="item.authType === 1?true:false">
        <div class="lab" :class="{'active': it.isActive}" v-for="(it,idx) in item.customerLevel" :key="idx" @click="handleActive(it)">
          <i class="el-icon-success" v-if="it.isActive"></i>{{it.value}}
        </div>
        <div class="lab" :class="{'active': it.isActive}" v-for="(it,idx) in item.technicalServiceLevel" :key="idx" @click="handleActive(it)">
          <i class="el-icon-success" v-if="it.isActive"></i>{{it.value}}
        </div>
        <div class="lab" :class="{'active': it.isActive}" v-for="(it,idx) in item.registerRole" :key="idx" @click="handleActive(it)">
          <i class="el-icon-success" v-if="it.isActive"></i>{{it.value}}
        </div>
        <div class="lab" :class="{'active': it.isActive}" v-for="(it,idx) in item.insideStaff" :key="idx" @click="handleActive(it)">
          <i class="el-icon-success" v-if="it.isActive"></i>{{it.value}}
        </div>
      </el-form-item>
      <el-form-item label="收费金额：" prop="feeAmount" v-if="item.authType === 2" :rules="{ pattern: /^\d+(\.\d{1,2})?$/, message: '必须为数字值', trigger: 'blur' }">
        <el-input v-model="form.feeAmount" placeholder="请输入收费金额">
          <i slot="suffix" class="el-input__icon">元</i>
        </el-input>
      </el-form-item>
      <el-form-item label="视频课免费观看：" prop="freeWatchNum" v-if="item.authType === 2" :rules="{ pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }">
        <el-input v-model="form.freeWatchNum" placeholder="请输入视频课免费观看节数">
          <i slot="suffix" class="el-input__icon">节</i>
        </el-input>
      </el-form-item>
      <el-form-item label="学分查看标准：" prop="lookCredits" class="width100" v-if="item.authType === 3" :rules="{ pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }">
        <el-input v-model="form.lookCredits" placeholder="请输入学分查看标准">
          <i slot="suffix" class="el-input__icon">学分</i>
        </el-input>
      </el-form-item>
    </div>

  </div>
</template>
<script>
import customerLevelApi from '@/api/sys/customerLevel'
import sysRoleApi from '@/api/sys/sysRole'
import technicalServiceLevelApi from '@/api/sys/technicalServiceLevel'
export default {
  props: ['form'],
  data() {
    return {
      isAjax: 0,
      options: {
        customerLevel: [],  //   业务线-客户级别
        registerRole: [],   //职能线-用户角色
        technicalServiceLevel: [],  //技术线-技术线级别
        insideStaff: [{ key: 1, value: '内部员工' }]  //内部员工
      },
    }
  },
  created() {
    this.getCustomerLevel()
    this.getRegisterRole()
    this.getTechnicalServiceLevel()
  },
  methods: {
    getCustomerLevel() {
      customerLevelApi.fetchList().then(({ data }) => {
        let arr = []
        data.forEach(item => {
          arr.push({ value: item.name, key: item.id })
        })
        this.options.customerLevel = arr;
        this.isAjax++
      })
    },
    getTechnicalServiceLevel() {
      technicalServiceLevelApi.findOptions().then(({ data }) => {
        this.options.technicalServiceLevel = data
        this.isAjax++
      })
    },
    getRegisterRole() {
      sysRoleApi.fetchList({ pageNo: 1, pageSize: 1000, roleType: 2 }).then(({ data }) => {
        let arr = []
        data.list.forEach(item => {
          arr.push({ value: item.roleName, key: item.id })
        })
        this.options.registerRole = arr
        this.isAjax++
        this.clacFuc()
      })
    },
    clacFuc() {
      let { customerLevel, technicalServiceLevel, registerRole, insideStaff } = this.options;
      if (this.isAjax === 3) {
        for (let i = 0; i < this.form.authData.length; i++) {
          if (i === 2) {
            //处理 权限只有体验班、研修班
            let customerLevelArr = JSON.parse(JSON.stringify(customerLevel))
            //筛选需要的
            const neededIds = [6, 7];
            customerLevelArr = customerLevelArr.filter(obj => neededIds.includes(obj.key));
            this.form.authData[i].customerLevel = customerLevelArr
            this.form.authData[i].technicalServiceLevel = []
            this.form.authData[i].registerRole = []
            this.form.authData[i].insideStaff = []
          } else {
            let customerLevelArrNew = JSON.parse(JSON.stringify(customerLevel))
            if (i === 1) {
              //过滤不需要的  
              const neededIds1 = [1, 2, 3];
              technicalServiceLevel = technicalServiceLevel.filter(item => !neededIds1.includes(item.key))
              const neededIds2 = [1, 2];
              customerLevelArrNew = customerLevelArrNew.filter(item => !neededIds2.includes(item.key))
            }
            this.form.authData[i].customerLevel = customerLevelArrNew
            this.form.authData[i].technicalServiceLevel = JSON.parse(JSON.stringify(technicalServiceLevel))
            // this.form.authData[i].registerRole = JSON.parse(JSON.stringify(registerRole))
            this.form.authData[i].registerRole = []
            this.form.authData[i].insideStaff = i === 1 ? [] : JSON.parse(JSON.stringify(insideStaff))
          }

        }
        this.calcActiveItem()
        this.$forceUpdate();
      } else {
        setTimeout(() => {
          this.clacFuc()
        }, 1000)
      }
    },
    calcActiveItem() {
      if (!this.form) return
      //freeLearningAuth 免费学习权限 paidLearningAuth 收费学习权限  lookCreditAuth 查看学习权限
      // customerLevel  technicalServiceLevel  registerRole
      let { freeLearningAuth, lookCreditAuth, paidLearningAuth } = this.form;

      freeLearningAuth && freeLearningAuth.forEach(item => {
        let key = item.levelSource === 1 ? 'customerLevel' : (item.levelSource === 2 ? 'technicalServiceLevel' : (item.levelSource === 3 ? 'registerRole' : 'insideStaff'))
        let findAuth = this.form.authData.find(it => it.authType === 1)
        let list = findAuth[key];
        let find = list.find(it => it.key === item.levelId)
        if (find) find.isActive = true
      })
      paidLearningAuth && paidLearningAuth.forEach(item => {
        let key = item.levelSource === 1 ? 'customerLevel' : (item.levelSource === 2 ? 'technicalServiceLevel' : (item.levelSource === 3 ? 'registerRole' : 'insideStaff'))
        let findAuth = this.form.authData.find(it => it.authType === 2)
        let list = findAuth[key];
        let find = list.find(it => it.key === item.levelId)
        if (find) find.isActive = true
      })
      lookCreditAuth && lookCreditAuth.forEach(item => {
        let key = item.levelSource === 1 ? 'customerLevel' : (item.levelSource === 2 ? 'technicalServiceLevel' : (item.levelSource === 3 ? 'registerRole' : 'insideStaff'))
        let findAuth = this.form.authData.find(it => it.authType === 3)
        let list = findAuth[key];
        let find = list.find(it => it.key === item.levelId)
        if (find) find.isActive = true
      })
    },
    handleActive(it) {
      it.isActive = !it.isActive
      this.$forceUpdate();
    },
  }
}
</script>
<style lang="scss" scoped>
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
.jurisd {
  .lab {
    font-size: 14px;
    color: #8f8e8e;
    border-radius: 4px;
    padding: 0 18px;
    display: inline-block;
    border: 1px solid #c5c5c5;
    margin: 5px;
    position: relative;
    cursor: pointer;
    &.active {
      background: #5dbde7;
      color: #fff;
      border-color: #5dbde7;
    }
    i {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
}
</style>